import { throttle } from "redux-saga";
import { call, select, put } from "redux-saga/effects";
import companyToken from "Utils/companyToken";
import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";

import {
  ADD_PLAN_TO_CART,
  ADD_UPGRADE_OPTION,
  REMOVE_UPGRADE_OPTION,
  ADD_PACKAGE_TO_CART,
  cartUpdateSuccess,
  updateCartRelatedPlanIDs,
} from "Common/CartService/Actions";
import { getCart } from "Common/CartService/Selectors";

function updateCartApi(cart, companyIdToken) {
  const payload = {
    plan_ids: cart.medical,
    dental_plan_id: cart.dental,
    vision_plan_id: cart.vision,
    life_plan_id: cart.life,
    short_term_disability_plan_id: cart.short_term_disability,
    long_term_disability_plan_id: cart.long_term_disability,
  };
  return fetchWithCSRFToken(`/employer-application/update-cart?company_id_token=${companyIdToken}`, {
    method: "POST",
    body: JSON.stringify({
      company_policy: { ...payload },
    }),
    processData: false,
  }).then((response) => response.json());
}

function* updateCart(action) {
  const cart = yield select(getCart);
  let companyIdToken = companyToken() || action.companyIdToken;

  if (!companyIdToken) {
    // Fallback to try to get token from state.
    const { id_token, idToken } = yield select((state) => state?.companyProfile) || {};
    companyIdToken = id_token || idToken;
  }

  const response = yield call(updateCartApi, cart, companyIdToken);
  yield put(updateCartRelatedPlanIDs(response.relatedCartPlanIds));
  yield put(cartUpdateSuccess(action));
}

export function* watchAddPlanToCart() {
  yield throttle(350, [ADD_PLAN_TO_CART, ADD_UPGRADE_OPTION, REMOVE_UPGRADE_OPTION, ADD_PACKAGE_TO_CART], updateCart);
}
